import { useAuth } from "@/context/AuthContext";
import { Brand } from "@/components/Brand";

const AVATAR =
  "https://images.unsplash.com/photo-1560250097-0b93528c311a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBidXNpbmVzcyUyMG1hbiUyMHBvcnRyYWl0fGVufDB8fHx8MTc4Mzc0NjE4OHww&ixlib=rb-4.1.0&q=85";

export function Topbar() {
  const { user } = useAuth();
  return (
    <header
      className="sticky top-0 z-20 bg-white/95 backdrop-blur border-b border-gray-200"
      data-testid="topbar"
    >
      <div className="flex items-center justify-between px-5 lg:px-8 h-16">
        <div className="lg:hidden">
          <Brand size="sm" showTagline={false} />
        </div>
        <div className="hidden lg:block" />

        <div className="flex items-center gap-3" data-testid="topbar-org">
          <div className="text-right leading-tight">
            <p className="text-sm font-bold text-brand-graphite">{user?.organization_name}</p>
            <p className="text-xs text-brand-gray/60 font-medium">{user?.name}</p>
          </div>
          <img
            src={AVATAR}
            alt={user?.name}
            className="h-9 w-9 rounded-full object-cover ring-2 ring-brand-yellow"
            data-testid="user-avatar"
          />
        </div>
      </div>
    </header>
  );
}
